import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

const Home = () => {
  // Capturamos los query params actuales para no perderlos en esta redirección
  const location = useLocation();
  return <Redirect to={{ pathname: '/lawyer/home', search: location.search }} />;
};

export default Home;
